import axios from 'axios';

const getReferrerInfo = (code) => axios.get(`invitation/public/userReferral/${code}`);

const sendReferral = (referral) => axios.post(`invitation/userReferral/`, referral);


export default {
  getReferrerInfo,
  sendReferral,
};



// WEBPACK FOOTER //
// ./src/api/referral.js